// import React, { useEffect, useState } from "react";
// import CourseHeader from "../../../Components/CourseHeader";
// import { icons } from "../../../Assests/icons-imports/icons";
// import { Tabs } from "antd";
// import BasicInfo from "../../../Components/UserTabs/BasicInfo";
// import LoginCredentials from "../../../Components/UserTabs/LoginCredentials";
// import SocialInformation from "../../../Components/UserTabs/SocialInformation";
// import Finish from "../../../Components/UserTabs/Finish";
// import { InfoCircleFilled } from "@ant-design/icons";
// import { LoginOutlined } from "@ant-design/icons";
// import { WifiOutlined } from "@ant-design/icons";
// import { PlayCircleOutlined } from "@ant-design/icons";
// // import { EuroCircleOutlined } from "@ant-design/icons";
// import { Helmet } from "react-helmet-async";
// import usePost from "../../../services/usePost";
// import usePut from "../../../services/usePut";
// import useGetApi from "../../../services/useGetApi";
// import { useNavigate, useParams } from "react-router-dom";

// const onChange = (key) => {
//   console.log(key);
// };

// const AddNewAdmin = () => {
//   const [loading, setLoading] = useState(false);

//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [basicInfo, setBasicInfo] = useState({});
//   const [loginCredentials, setLoginCredentials] = useState({});
//   const [socialInformation, setSocialInformation] = useState({});

//   const [isPostLoading, postError, postData] = usePost();
//   const [isPutLoading, putError, putData] = usePut();

//   const [isLoading, error, userData, getData] = useGetApi(
//     `/users/${id}`,
//     [],
//     true
//   );

//   useEffect(() => {
//     if (id) {
//       console.log("got user id here", id);
//       getData(`users/${id}`);
//     }
//   }, [id]);

//   useEffect(() => {
//     if (userData) {
//       setBasicInfo({
//         title: userData.title,
//         firstName: userData.firstName,
//         lastName: userData.lastName,
//         biography: userData.biography,
//         phone: userData.phone,
//         address: userData.address,
//         imageUrl: userData.image,
//       });

//       setLoginCredentials({
//         email: userData.email,
//         password: "",
//       });

//       if (userData.socialLinks) {
//         let socialLinks = JSON.parse(userData.socialLinks);
//         setSocialInformation({
//           facebook: socialLinks.facebook ?? "",
//           twitter: socialLinks.twitter ?? "",
//           linkedin: socialLinks.linkedin ?? "",
//         });
//       }

//       console.log("Updated State:", {
//         basicInfo,
//         loginCredentials,
//         socialInformation,
//       });
//     }
//   }, [userData]);

//   const handleSubmit = async () => {
//     console.log("Submit button clicked");
//     const formData = {
//       basicInfo,
//       loginCredentials,
//       socialInformation,
//     };

//     let formDataToSend = {
//       title: basicInfo.title,
//       firstName: basicInfo.firstName,
//       lastName: basicInfo.lastName,
//       biography: basicInfo.biography,
//       phone: basicInfo.phone,
//       address: basicInfo.address,
//       image: basicInfo.imageUrl,

//       email: loginCredentials.email,
//       password: loginCredentials.password,

//       isInstructor: 0,
//       lastModified: 0,
//       socialLinks: JSON.stringify(socialInformation),
//     };

//     console.log(formDataToSend);

//     // Add your form submission logic here
//     setLoading(true);
//     try {
//       if (id) {
//         const res = await putData(`users/${id}`, formDataToSend, true);
//         if (res) {
//           navigate(-1);
//         }
//       } else {
//         const res = await postData("users/admin", formDataToSend, true);
//         if (res.id) {
//           navigate(-1);
//         }
//       }
//     } catch (err) {
//       console.error("Submission error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const items = [
//     {
//       key: "1",
//       label: (
//         <>
//           <InfoCircleFilled /> Basic Info
//         </>
//       ),
//       children: (
//         <BasicInfo
//           data={basicInfo}
//           setData={setBasicInfo}
//           setLoading={setLoading}
//         />
//       ),
//     },
//     {
//       key: "2",
//       label: (
//         <>
//           <LoginOutlined /> Login credentials
//         </>
//       ),
//       children: (
//         <LoginCredentials
//           data={loginCredentials}
//           setData={setLoginCredentials}
//         />
//       ),
//     },
//     {
//       key: "3",
//       label: (
//         <>
//           <WifiOutlined /> Social information
//         </>
//       ),
//       children: (
//         <SocialInformation
//           data={socialInformation}
//           setData={setSocialInformation}
//         />
//       ),
//     },
//     {
//       key: "4",
//       label: (
//         <>
//           <PlayCircleOutlined />
//           Finish
//         </>
//       ),
//       children: !loading && <Finish onSubmit={handleSubmit} />,
//     },
//   ];

//   return (
//     <div>
//       <Helmet>
//         <title>Add Admin | LMS-admin</title>
//       </Helmet>
//       <div className="d-flex gap-3 px-3">
//         <div className="mt-5 pt-5 w-100">
//           <CourseHeader
//             header={"Admin add"}
//             btnName={"Back to admin"}
//             icon={icons.apple_icon}
//             redirectTo={"/users/admin-users"}
//           />
//           <div className="bg-white p-3 mt-3">
//             <div>Admin add form</div>
//             <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddNewAdmin;

import React,{useState,useEffect} from "react";
import { Form, Input, Tabs, Button } from "antd";
import { CheckCircleOutlined, LockOutlined, ShareAltOutlined, UserOutlined } from "@ant-design/icons";
import ImageUploader from "../../../Components/ImageUploader/ImageUploader";
import { Helmet } from "react-helmet-async";
import usePost from "../../../services/usePost";
import usePut from "../../../services/usePut";
import useGetApi from "../../../services/useGetApi";
import { useNavigate, useParams } from "react-router-dom";

const { TabPane } = Tabs;

const AddNewAdmin = () => {
  const [form] = Form.useForm();
  const [activeTab, setActiveTab] = useState("1");
  const [imageUrl,setImageUrl] = useState('')
  const [loading, setLoading] = useState(false);

  const { id } = useParams();
  const navigate = useNavigate();


  const [isPostLoading, postError, postData] = usePost();
  const [isPutLoading, putError, putData] = usePut();

  const [isLoading, error, userData, getData] = useGetApi(
    `/users/${id}`,
    [],
    true
  );

  useEffect(() => {
    if (id) {
      console.log("got user id here", id);
      getData(`users/${id}`);
    }
  }, [id]);

    const fieldTabMap = {
    title: "1",
    firstName: "1",
    lastName: "1",
    biography: "1",
    phone: "1",
    address: "1",
    email: "2",
    password: "2",
    facebook: "3",
    twitter: "3",
    linkedin: "3",
  };

  useEffect(() => {
  if (id && userData) {
    let socialLinks = {};
    try {
      socialLinks = JSON.parse(userData.socialLinks || '{}');
    } catch (error) {
      console.warn("Failed to parse socialLinks:", error);
    }
    form.setFieldsValue({
      title: userData.title,
      firstName: userData.firstName,
      lastName: userData.lastName,
      biography: userData.biography,
      phone: userData.phone,
      address: userData.address,
      email: userData.email,
      password: "", // Leave empty for security (don't prefill passwords)
      facebook:socialLinks.facebook,
      twitter: socialLinks.twitter,
      linkedin: socialLinks.linkedin,
    });

    if (userData.image) {
      setImageUrl(userData.image);
    }
  }
}, [id, userData]);


  const handleImageUpload = (filePath) => {
    // setData((prev) => ({
    //   ...prev,
    //   imageUrl: filePath,
    // }));
    console.log(filePath,'file......................')
    setImageUrl(filePath)
  };

  const onSubmit = async () => {
    setLoading(true); 

    try {
      const values = await form.validateFields();

      const formDataToSend = {
        image:imageUrl,
        socialLinks:JSON.stringify({
          facebook: values.facebook ?? "",
          twitter: values.twitter ?? "",
          linkedin: values.linkedin ?? "",
        }),
        ...values,
      };

      let res;

      if (id) {
        res = await putData(`users/${id}`, formDataToSend, true);
      } else {
        res = await postData("users/admin", formDataToSend, true);
      }

      if (res && (res.id || id)) {
        navigate(-1); 
      }
    } catch (error) {
      // Handle form validation error (e.g. required fields)
      if (error?.errorFields?.length > 0) {
        const firstErrorField = error.errorFields[0].name[0];
        if (fieldTabMap[firstErrorField]) {
          setActiveTab(fieldTabMap[firstErrorField]); // Switch to tab with error
        }
      } else {
        console.error("Submission error:", error); // API or unknown error
      }
    } finally {
      setLoading(false); // Reset loading state
    }
  };


  // const onFinish = (values) => {
  //   console.log("Form submitted:", values);
  // };

  return (
    <div className="bg-white mt-5">
       <Helmet>
        <title>Add Admin | LMS-admin</title>
       </Helmet>
      <Form
      form={form}
      layout="vertical"
      // onFinish={onFinish}
      style={{ maxWidth: 600, margin: "0 auto", marginTop: 40 }}
      >
        <Tabs  activeKey={activeTab} onChange={setActiveTab}>
          {/* Tab 1 */}
          <TabPane tab={
            <span>
              <UserOutlined style={{ marginRight: 8 }} />
              Basic Info
            </span>
          } key="1"
          >
            <Form.Item label="Title" name="title" rules={[{ required: true,message:"Please enter your title" }]}>
              <Input />
            </Form.Item>
            <Form.Item label="First Name" name="firstName" rules={[{ required: true,message:"Please enter your firstname" }]}>
              <Input />
            </Form.Item>
            <Form.Item label="Last Name" name="lastName" rules={[{ required: true,message:"Please enter your lastname" }]}>
              <Input />
            </Form.Item>
            <Form.Item label="Biography" name="biography" rules={[{ required: true,message:"Please enter your biography" }]}>
              <Input.TextArea />
            </Form.Item>
            <Form.Item label="Phone" name="phone" rules={[{ required: true,message:"Please enter your phone number"}]}>
              <Input />
            </Form.Item>
            <Form.Item label="Address" name="address" rules={[{ required: true,message:"Please enter your address" }]}>
              <Input />
            </Form.Item>
            <div>
                <h6 className="fw-bold">Select Image</h6>
                <ImageUploader
                  onImageUpload={handleImageUpload}
                  imageUrl={imageUrl}
                  subdir="user_images"
                />
            </div>
          </TabPane>

          {/* Tab 2 */}
          <TabPane 
             tab={
                <span>
                  <LockOutlined style={{ marginRight: 8 }} />
                  Account
                </span>
              }         
             key="2"
          >
            <Form.Item label="Email" name="email" rules={[{ required: true, type: "email",message:"Please enter your email"}]}>
              <Input />
            </Form.Item>
            <Form.Item label="Password" name="password" rules={[{ required: true,message:"Please enter your password" }]}>
              <Input.Password />
            </Form.Item>
          </TabPane>

          {/* Tab 3 */}
          <TabPane 
             tab={
                <span>
                  <ShareAltOutlined style={{ marginRight: 8 }} />
                  Social
                </span>
              }
            key="3"
          >
            <Form.Item label="Facebook" name="facebook">
              <Input />
            </Form.Item>
            <Form.Item label="Twitter" name="twitter">
              <Input />
            </Form.Item>
            <Form.Item label="LinkedIn" name="linkedin">
              <Input />
            </Form.Item>
          </TabPane>

          {/* Tab 4 */}
          <TabPane
            tab={
              <span>
                <CheckCircleOutlined style={{ marginRight: 8 }} />
                Finish
              </span>
            }
            key="4"
          >
             <div className="d-flex justify-content-center align-items-center flex-column">
               <p><strong>Thank you</strong></p>
               <p>You are just one click away</p>
                <Form.Item>
                  <Button type="primary" onClick={onSubmit}>
                    Submit
                  </Button>
                </Form.Item>
             </div>
          </TabPane>
        </Tabs>
      </Form>
    </div>
  );
};

export default AddNewAdmin;

